import React, { useContext } from 'react';
export function makeServices(services) {
    /**
     * Create default (empty) services context.
     * Eslint usually will block casting an Object Literal, we are disabling this
     * for the createContext call in the schematic.
     */
    const ServicesContext = React.createContext({}); // eslint-disable-line
    /**
     * Convenience component to provide services context.
     * @param contextProps - Allows for override of injected service dependencies.
     */
    const ServicesProvider = ({ contextProps = services, children }) => (React.createElement(ServicesContext.Provider, { value: contextProps }, children));
    const useServices = () => useContext(ServicesContext);
    return { ServicesProvider, useServices, ServicesContext };
}
//# sourceMappingURL=makeServices.js.map